export const FP_MOBILE_EDITOR_STACKING_ORDER = {
  FP_BACKGROUND_IMAGE_Z_INDEX: 0,
  FP_CONTENT_Z_INDEX: 1,
  FP_GATE_PREVIEW_MODAL_Z_INDEX: 2,
  BOTTOM_NAV_Z_INDEX: 400
}
